(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cim-menu-tabs"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('cim-menu-tabs')) {
        customElements.define('cim-menu-tabs', class extends HTMLElement {
            connectedCallback() {
                this.tabs = [...this.querySelectorAll('[role="tab"]')];
                this.list = this.querySelector('[role="tablist"]');
                this.indicator = this.querySelector('[data-cim-menu-tabs-indicator]');
                // Fond noir placé sans animation au chargement et au redimensionnement
                this.placeIndicator(false);
                this.list.classList.add('has-indicator');
                if (window.ResizeObserver) new ResizeObserver(() => this.placeIndicator(false)).observe(this.list);
                this.tabs.forEach((tab, index) => {
                    tab.addEventListener('click', () => this.select(index));
                    tab.addEventListener('keydown', (event) => {
                        const keys = { ArrowRight: 1, ArrowLeft: -1 };
                        if (event.key in keys) {
                            event.preventDefault();
                            const next = (index + keys[event.key] + this.tabs.length) % this.tabs.length;
                            this.select(next);
                            this.tabs[next].focus();
                        }
                    });
                });
            }

            placeIndicator(animate) {
                const active = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
                if (!active || !this.indicator) return;
                this.list.classList.toggle('no-transition', !animate);
                this.indicator.style.width = active.offsetWidth + 'px';
                this.indicator.style.transform = 'translateX(' + active.offsetLeft + 'px)';
                if (!animate) {
                    void this.indicator.offsetWidth;
                    this.list.classList.remove('no-transition');
                }
            }

            select(index) {
                if (this.tabs[index].getAttribute('aria-selected') === 'true') return;
                this.tabs.forEach((tab, i) => {
                    const active = i === index;
                    tab.setAttribute('aria-selected', active);
                    tab.tabIndex = active ? 0 : -1;
                    const panel = document.getElementById(tab.getAttribute('aria-controls'));
                    if (!panel) return;
                    panel.hidden = !active;
                    panel.classList.remove('is-entering');
                    if (active) {
                        void panel.offsetWidth; // relance l'animation de fondu
                        panel.classList.add('is-entering');
                    }
                });
                this.placeIndicator(true);
            }
        });
    }

  } catch(e) { console.error(e); }
})();
})();
